var _excluded = ["appearance", "children", "icon", "iconPosition", "size", "stretched", "scope"],
  _excluded2 = ["forwardRef", "type"],
  _excluded3 = ["forwardRef", "type"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import warn from './util/warn';
import button from './components/button/button.style';
import * as iconStyles from './styles/icon';
import appearanceStyles from './styles/appearances';
import * as sizeStyles from './styles/sizes';
import { jsx as ___EmotionJSX } from "@emotion/core";
var developmentWarning = warn('development');
export var AppearanceMap;
(function (AppearanceMap) {
  AppearanceMap["regular"] = "regular";
  AppearanceMap["muted"] = "muted";
  AppearanceMap["lowlight"] = "lowlight";
  AppearanceMap["outline"] = "outline";
  AppearanceMap["outlineAccent"] = "outlineAccent";
  AppearanceMap["ghost"] = "ghost";
  AppearanceMap["ghostPrimary"] = "ghostPrimary";
  AppearanceMap["link"] = "link";
  AppearanceMap["highlight"] = "regular";
})(AppearanceMap || (AppearanceMap = {}));
export var LegacyAppearances = ['highlight'];
function BaseButton(props) {
  var _props$appearance = props.appearance,
    appearance = _props$appearance === void 0 ? 'regular' : _props$appearance,
    children = props.children,
    icon = props.icon,
    _props$iconPosition = props.iconPosition,
    iconPosition = _props$iconPosition === void 0 ? 'left' : _props$iconPosition,
    _props$size = props.size,
    size = _props$size === void 0 ? 'regular' : _props$size,
    stretched = props.stretched,
    _props$scope = props.scope,
    scope = _props$scope === void 0 ? 'embedded' : _props$scope,
    discriminatedProps = _objectWithoutProperties(props, _excluded);
  var mappedAppearance = AppearanceMap[appearance];
  if (LegacyAppearances.includes(appearance)) {
    developmentWarning("Deprecation warning: The \"".concat(appearance, "\" Button appearance is deprecated. Use ").concat(mappedAppearance, " instead."));
  }
  var content = children;
  if (icon) {
    content = ___EmotionJSX(React.Fragment, null, ___EmotionJSX("span", {
      css: iconStyles.icon(size, iconPosition),
      key: "icon"
    }, icon), children && ___EmotionJSX("span", {
      css: iconStyles.label,
      key: "label"
    }, children));
  }
  var iconOnly = Boolean(icon) && !children;
  var buttonCss = [button({
    type: props.type,
    stretched,
    iconOnly
  }), props.icon && iconStyles.wrapper(iconPosition), sizeStyles[size](iconOnly, scope), appearanceStyles[mappedAppearance]];
  if (discriminatedProps.type === 'link' && discriminatedProps.href) {
    var _forwardRef = discriminatedProps.forwardRef,
      _type = discriminatedProps.type,
      linkProps = _objectWithoutProperties(discriminatedProps, _excluded2);
    if (linkProps.target === '_blank' && (!linkProps.rel || !linkProps.rel.includes('noopener'))) {
      developmentWarning('Security risk: missing rel="noopener" on anchor with target _blank');
    }
    return ___EmotionJSX("a", _extends({}, linkProps, {
      ref: _forwardRef,
      css: buttonCss
    }), content);
  }
  var forwardRef = discriminatedProps.forwardRef,
    _discriminatedProps$t = discriminatedProps.type,
    type = _discriminatedProps$t === void 0 ? 'button' : _discriminatedProps$t,
    buttonProps = _objectWithoutProperties(discriminatedProps, _excluded3);
  return ___EmotionJSX("button", _extends({
    type: type
  }, buttonProps, {
    ref: forwardRef,
    css: buttonCss
  }), content);
}
BaseButton.displayName = 'BaseButton';
export default BaseButton;